import { TASK_MANAGEMENT_ROLES } from './dashboardRoles';
import type { UserRole } from '../types';
import { GUEST_REPLY_SETTINGS_ROLES, hasDashboardRole, isRouteEnabled, getTenantRuntime, type CellFeatureState, type TenantWebConfig } from './tenant';

export interface NavigationRoute { path: string; label: string; requiredRole?: readonly UserRole[] }
export interface NavigationArea { label: string; routes: readonly NavigationRoute[]; requiredRole?: readonly UserRole[] }
const management = ['manager', 'admin'] as const;
export const navigationAreas: readonly NavigationArea[] = [
  { label: 'Heute', routes: [{ path: '/', label: 'Heute' }] },
  { label: 'Buchungen', routes: [{ path: '/bookings', label: 'Liste' }, { path: '/calendar', label: 'Kalender' }] },
  { label: 'Aufgaben', routes: [{ path: '/tasks', label: 'Aufgaben', requiredRole: TASK_MANAGEMENT_ROLES }] },
  { label: 'Reinigung', routes: [{ path: '/cleaning', label: 'Reinigung' }] },
  { label: 'Nachrichten', routes: [
    { path: '/messages?view=offen', label: 'Offen' },
    { path: '/messages?view=ohne-buchung', label: 'Ohne Buchung', requiredRole: ['support', 'manager', 'admin'] },
    { path: '/messages?view=emails', label: 'E-Mail-Liste' },
    { path: '/messages?view=anrufe', label: 'Anrufe' }, { path: '/feedback', label: 'Bewertungen', requiredRole: management },
  ] },
  { label: 'Einstellungen', routes: [
    { path: '/settings/pricing', label: 'Preise', requiredRole: ['owner', 'admin', 'manager'] },
    { path: '/settings/replies', label: 'Gästeantworten', requiredRole: GUEST_REPLY_SETTINGS_ROLES },
    { path: '/settings/mailbox', label: 'Postfach', requiredRole: management },
    { path: '/rules', label: 'Regeln', requiredRole: management },
    { path: '/voicebot', label: 'Voicebot', requiredRole: management },
    { path: '/faq', label: 'FAQ', requiredRole: management },
    { path: '/settings/team', label: 'Team', requiredRole: management },
    { path: '/users', label: 'Benutzer', requiredRole: ['admin'] },
  ] },
  { label: 'System', requiredRole: ['admin'], routes: [
    { path: '/monitoring', label: 'Monitoring', requiredRole: ['admin'] },
    { path: '/data-explorer', label: 'Datenexplorer', requiredRole: ['admin'] },
  ] },
];

export function availableNavigation(role: UserRole, features: CellFeatureState, config: TenantWebConfig = getTenantRuntime()): NavigationArea[] {
  return navigationAreas.filter(area => !area.requiredRole || hasDashboardRole({ ...config, role }, [...area.requiredRole]))
    .map(area => ({ ...area, routes: area.routes.filter(route => isRouteEnabled(route.path, features, config)
      && (!route.requiredRole || hasDashboardRole({ ...config, role }, [...route.requiredRole]))) }))
    .filter(area => area.routes.length > 0);
}
